/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RetentionPaymentConfig {
  configId?: number;
  configValue?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  enumValue?: RetentionPaymentConfig.EnumValueEnum;
  label?: string;
  username?: string;
}
export namespace RetentionPaymentConfig {
  export type EnumValueEnum =
    | 'RENEWAL_BOT_ATTEMPT_DAY'
    | 'INSTANT_RETENTION_ATTEMPT_DAY'
    | 'BACKUP_CARD_ATTEMPT_DAY';
  export const EnumValueEnum = {
    RENEWALBOTATTEMPTDAY: 'RENEWAL_BOT_ATTEMPT_DAY' as EnumValueEnum,
    INSTANTRETENTIONATTEMPTDAY:
      'INSTANT_RETENTION_ATTEMPT_DAY' as EnumValueEnum,
    BACKUPCARDATTEMPTDAY: 'BACKUP_CARD_ATTEMPT_DAY' as EnumValueEnum
  };
}
